export default {
  // 用户登录
  sendLogin: '/login',

  // 单位登录用户修改密码
  updPwd: '/common/updPwd',

  // 获取单位登录验证码base64数据
  getCaptchaBase64: '/common/guest/getCaptchaBase64',

  // 校验单位登录验证码
  validateCaptcha: '/common/guest/validateCaptcha',

  // 退出登录
  sendLoginOut: '/logout',

  //获取手机号验证码
  getPhoneMessage: '/common/guest/sendCode'
}



// WEBPACK FOOTER //
// ./src/api/UserLogin/urls.js